import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FrameHistory } from '../../../../models/manager-content-vehicle-history-drawer.model';
import { AsideHistoryCard } from '../../models/content-vehicle-history-drawer.model';

@Component({
  selector: 'frames-history-list',
  templateUrl: './frames-history-list.component.html',
  styleUrls: ['./frames-history-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FramesHistoryListComponent {
  @Input() frames: AsideHistoryCard<'frames'>[] = [];
  @Input() currentImei: string = '';
  @Input() currentState: Map<string, Map<string, boolean>> = new Map();
  @Output() selectCard = new EventEmitter<any>();
  @Output() redirectTo = new EventEmitter<string>();

  readonly itemSize = 80; // Altura fija para frames

  isCardSelected(id: number, type: string, variant: string = 'stop'): boolean {
    const currentImei = this.currentImei;
    if (!currentImei) return false;

    const imeiMap = this.currentState.get(currentImei);
    if (!imeiMap) return false;

    const key = `${id}-${type}-${variant}`;
    return imeiMap.get(key) ?? false;
  }

  trackByFrameId(_index: number, frame: AsideHistoryCard<'frames'>) {
    return `${frame.id}-${frame.type}-${frame.variant}`;
  }

  onSelectCard(event: any): void {
    this.selectCard.emit(event);
  }

  onRedirectTo(type: string): void {
    this.redirectTo.emit(type);
  }

  get isEmpty(): boolean {
    return !this.frames || this.frames.length === 0;
  }

  get emptyMessage(): string {
    return 'No hay frames registrados en este período de tiempo';
  }

  get suggestionMessage(): string {
    return '¿Te gustaría revisar las paradas o eventos del vehículo?';
  }
}
